// Components/ui
import { Adornment } from './components';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';

export type AdornmentStatus = 'idle' | 'loading' | 'available' | 'unavailable';

type StatusAdornmentProps = {
  status: AdornmentStatus;
  text?: string;
};

const StatusAdornment = ({ status, text }: StatusAdornmentProps) => {

  const textAdornment = text ? (
    <Typography marginRight={0.5}>
      {text}
    </Typography>
  ) : null;

  return (
    <InputAdornment position="end">
      {textAdornment}
      <div style={{ width: 30, display: 'flex', justifyContent: 'center' }}>
        <Adornment status={status} />
      </div>
    </InputAdornment>
  );
};

export default StatusAdornment;
